export function isTempAdminAccessActive(
  temporaryPermissions: { expiry: string; scopes?: string[] } | null | undefined,
): boolean {
  if (!temporaryPermissions?.expiry) return false;

  const expiryMs = new Date(temporaryPermissions.expiry).getTime();
  if (Number.isNaN(expiryMs)) return false;

  return expiryMs > Date.now();
}
